export default "__VITE_ASSET__DFdIFwug__";